<template>
    <div class="category-tags">
        <el-tag
            v-for="(tag, index) in categories"
            :key="index"
            class="mr-10 mb-10"
            closable
            @close="removeFromList(index)"
        >
            {{ typeCategorization === 'syndigo_categorized'
            ? tag.path.join(' | ')
            : tag.charAt(0).toUpperCase() + tag.slice(1).split('-').join(' ') }}
        </el-tag>
    </div>
</template>

<script setup>
const emit = defineEmits()

const props = defineProps({
    categories: {
        type: Array,
        required: true
    },
    typeCategorization: {
        type: String,
        required: 'changed'
    }
})

function removeFromList(index) {
    emit('removeFromList', index)
}
</script>
